<template>
  <div class="mg-t-80 mg-b-40">
    <div class="justify-content-center">
      <img src="/static/image/logo.png" style="height: 70px;"/>
      <div class="text-strong fs-45 mg-l-10" style="vertical-align: middle">Anymo</div>
    </div>
    <div class="fs-20 text-strong mg-t-15 text-align-center c-4">终身受用的抗遗忘卡片记忆笔记</div>
    <div class="fs-14 mg-t-15 text-align-center c-4">立即下载体验，胜过千言万语</div>
    <div class="mg-t-80" :class="isMobileScreen?'text-align-center':'justify-content-center'"
         style="margin-left: auto; margin-right: auto;">
      <a @click="goAndroid" class="display-inline-block pd-30 c-4 cursor-pointer">
        <div class="justify-content-center">
          <div class="w-120 h-120 shadow-2 bdr-circular justify-content-center align-items-center">
            <i class="fa fa-android fa-4x"></i>
          </div>
        </div>
        <div class="text-align-center mg-t-20">
          <a class="c-6 fs-16">Android</a>
          <div class="fs-12 c-app-green"></div>
        </div>
      </a>
      <a href="https://memo93.com/anymo/index/appstore" target="_blank" class="display-inline-block pd-30 c-4">
        <div class="justify-content-center">
          <div class="w-120 h-120 shadow-2 bdr-circular justify-content-center align-items-center">
            <i class="fa fa-apple fa-4x"></i>
          </div>
        </div>
        <div class="text-align-center mg-t-20">
          <span class="c-6 fs-16">IOS</span>
          <div class="fs-12 c-9 lh-14"></div>
        </div>
      </a>
      <a @click="goWin" class="display-inline-block pd-30 c-4 cursor-pointer">
        <div class="justify-content-center">
          <div class="w-120 h-120 shadow-2 bdr-circular justify-content-center align-items-center">
            <i class="fa fa-windows fa-4x"></i>
          </div>
        </div>
        <div class="text-align-center mg-t-20">
          <span class="c-6 fs-16">Windows</span>
          <div class="fs-12 c-9">(不支持win7/win8)</div>
        </div>
      </a>
      <div class="display-inline-block pd-30 c-4">
        <div class="justify-content-center cursor-pointer" @click="goMacIntel">
          <div class="w-120 h-120 shadow-2 bdr-circular justify-content-center align-items-center">
            <!--            <i class="fa fa-apple fa-4x"></i>-->
            <img src="/static/image/AppStore.png" style="width: 48px"/>
          </div>
        </div>
        <div class="text-align-center mg-t-20">
          <span class="c-6">Mac版 Intel CPU</span>
          <div class="fs-12 c-9">(2020年前款式)</div>
        </div>
      </div>
      <div class="display-inline-block pd-30 c-4">
        <div class="justify-content-center cursor-pointer" @click="goMacM">
          <div class="w-120 h-120 shadow-2 bdr-circular justify-content-center align-items-center">
            <!--            <i class="fa fa-apple fa-4x"></i>-->
            <img src="/static/image/AppStore.png" style="width: 48px"/>
          </div>
        </div>
        <div class="text-align-center mg-t-20">
          <span class="c-6">Mac版 M系列CPU</span>
        </div>
      </div>
    </div>
    <div class="mg-t-80 w-400" style="margin-left: auto;margin-right: auto;">
      <div>
        <a id="max" href="#" @click="toWin" target="_blank" style="color:darkred;text-decoration: none;">📔Win版下载弹窗提示【通常不会下载...请确保信任】解决办法</a>
      </div>
      <div>
        <a id="max" href="#" @click="toMax" target="_blank" style="color:darkred;text-decoration: none;">📔Mac版首次运行提示【无法打开“Anymo”...】解决办法</a>
      </div>
      <el-tabs v-model="activeName" @tab-click="LogHandleClick">
        <el-tab-pane label="移动端App更新日志" name="1,2">
          <div v-for="(item,index) in logList">
            <h3>{{ item.title }}</h3>
            <div v-html="item.content"></div>
            <br>
          </div>
        </el-tab-pane>
        <el-tab-pane label="PC端更新日志" name="3">
          <div v-for="(item,index) in logList">
            <h3>{{ item.title }}</h3>
            <div v-html="item.content"></div>
            <br>
          </div>
        </el-tab-pane>
        <div v-if="showLoadMore" class="cursor-pointer c-app-green" @click="loadMore">查看更多...</div>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import request from '../../libs/api.request'
import MobileDetect from 'mobile-detect';

export default {
  name: 'download',
  data() {
    return {
      activeName: '1,2',//1为安卓，2为iOS，3为pc
      isMobileScreen: false,
      logList: [],
      page: 1,
      pageSize: 5,
      showLoadMore: true,
    }
  },
  methods: {
    LogHandleClick(tab, event) {
      let logName = localStorage.getItem('log_name');
      if (logName != tab.name) {
        this.page = 1;
        this.pageSize = 5;
        this.logList = [];
      }
      this.getAppLog();
    },
    toWin() {
      // 获取目标路由的完整路径
      const routePath = this.$router.resolve({name: 'win'}).href;
      // 使用 window.open() 在新标签页中打开目标路由
      window.open(routePath, '_blank');
    },
    toMax() {
      // 获取目标路由的完整路径
      const routePath = this.$router.resolve({name: 'max'}).href;
      // 使用 window.open() 在新标签页中打开目标路由
      window.open(routePath, '_blank');
    },
    isWeChat() {
      let ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') !== -1;
    },
    goAndroid() {
      if (this.isWeChat()) {
        alert('微信内无法下载，请点击右上角菜单选择浏览器打开');
      } else {
        this.$confirm('将要下载 Android 平台安装包，是否继续？', {
          confirmButtonText: '继续',
          cancelButtonText: '否',
          type: 'warning',
        }).then(async () => {
          window.open("/app-release.apk?t=" + (new Date().getTime()));
        }).catch((e) => {
          console.error(e)
        });
      }
    },
    goWin() {
      if (this.isWeChat()) {
        alert('微信内无法下载，请点击右上角菜单选择浏览器打开');
      } else {
        let img = `<img src='/static/image/win.png' width="350px"/>`;
        this.$confirm('将要下载 Windows 平台安装包，是否继续？部份浏览器会提示软件信任问题，如您无法正常下载，按如图' + img + '所示点击弹窗的右上角的三个点，再选择【保留】即可', {
          confirmButtonText: '继续',
          cancelButtonText: '否',
          dangerouslyUseHTMLString: true, // 启用 HTML
          type: 'warning',
        }).then(async () => {
          window.open("/app-win.exe");
        }).catch(() => {

        });
      }
    },
    goMacM() {
      if (this.isWeChat()) {
        alert('微信内无法下载，请点击右上角菜单选择浏览器打开');
      } else {
        this.$confirm('将要下载 Mac版 M系列CPU 平台安装包，是否继续？', {
          confirmButtonText: '继续',
          cancelButtonText: '否',
          type: 'warning',
        }).then(async () => {
          window.open("/app-mac-arm64.dmg");
        }).catch(() => {

        });
      }
    },
    goMacIntel() {
      if (this.isWeChat()) {
        alert('微信内无法下载，请点击右上角菜单选择浏览器打开');
      } else {
        this.$confirm('将要下载 Mac版 Intel CPU 平台安装包，是否继续？', {
          confirmButtonText: '继续',
          cancelButtonText: '否',
          type: 'warning',
        }).then(async () => {
          window.open("/app-mac-x64.dmg");
        }).catch(() => {

        });
      }
    },
    getAppLog() {
      localStorage.setItem('log_name', this.activeName);
      request.request({
        url: '/common/getAppLog',
        params: {type: this.activeName, page: this.page, size: this.pageSize}
      }).then(data => {
        console.log(data);
        if (data.length == 0) {
          this.showLoadMore = false;
        } else {
          this.showLoadMore = true;
        }
        this.logList = this.logList.concat(data);
      })
    },
    loadMore() {
      this.page++;
      this.pageSize = 10;
      this.getAppLog();
    },
  },
  mounted() {
    const md = new MobileDetect(window.navigator.userAgent);
    if (md.mobile()) {
      this.isMobileScreen = true;
    }
    this.getAppLog();
  },
  created() {

  },
}
</script>